import { useTeacherGet } from 'actions/teacher-v2';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const teacherGetAPIEmbed = {
  embed: ['creds', 'psm_info'],
};

export default function useGetTeacherInfo() {
  const history = useHistory();
  const {
    location: { pathname },
  } = history;

  const pathList = pathname && pathname.split('/');
  const isStudentTransferPath = pathList?.includes('student-transfer');
  const teacherId = pathList && pathList[pathList.length - 1];
  const { data: teacherDetail, get: getData, isProcessing, isProccessed } = useTeacherGet(
    teacherId,
    teacherGetAPIEmbed,
  );

  useEffect(() => {
    if (
      isStudentTransferPath &&
      teacherId &&
      !teacherDetail &&
      !isProcessing &&
      !isProccessed
    ) {
      getData(teacherId, teacherGetAPIEmbed);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return teacherDetail || {};
}
